import Vue from 'vue'
import Vuex from 'vuex'
import VueCookie from 'vue-cookie'
import VueMeta from 'vue-meta'
import store from './store'
import router from './router'
import App from './App.vue'

import '../node_modules/bootstrap/dist/css/bootstrap.css';
import '../node_modules/bootstrap-icons/font/bootstrap-icons.css';

Vue.use(Vuex);
Vue.use(VueMeta);
Vue.use(VueCookie);
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
